export const FULFILLMENT_CHANNEL_ID = 'fulfillment-channel';
